"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var image_png_1 = __importDefault(require("images/estimate_reentry_modal/image.png"));
var ENDPOINT = "/users/estimates/entries/";
var EstimateReentryModal = /** @class */ (function (_super) {
    __extends(EstimateReentryModal, _super);
    function EstimateReentryModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EstimateReentryModal.prototype.render = function () {
        var store = this.props.store;
        return (react_1.default.createElement(react_responsive_modal_1.default, { open: store.isOpen, onClose: store.handleClose },
            react_1.default.createElement("div", { className: "coModalEstimateReentryModal-Container" },
                react_1.default.createElement("div", { className: "coModalEstimateReentryModal-Text" },
                    "\u8FFD\u52A0\u3067\u7121\u6599\u67FB\u5B9A\u7533\u8FBC\u3067\u304D\u308B",
                    react_1.default.createElement("br", null),
                    "\u696D\u8005\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\uFF01"),
                react_1.default.createElement("div", { className: "coModalEstimateReentryModal-Text-appeal" }, "\u518D\u67FB\u5B9A\u3057\u3066\u307F\u3088\u3046\uFF01"),
                react_1.default.createElement("img", { className: "coModalEstimateReentryModal-Image lazyload", src: image_png_1.default }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("form", { action: ENDPOINT, method: "post" },
                        react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: store.authenticityToken }),
                        react_1.default.createElement("input", { type: "hidden", name: "estimate_entry[original_entry_id]", value: store.originalEntryId }),
                        react_1.default.createElement("input", { type: "submit", value: "\u518D\u67FB\u5B9A\u3059\u308B", className: "sw-Button sw-Button-controlMain coModalEstimateReentryModal-SubmitButton" })),
                    react_1.default.createElement("button", { className: "sw-Button sw-Button-default coModalEstimateReentryModal-BackButton", onClick: store.handleClose }, "\u3082\u3069\u308B")))));
    };
    EstimateReentryModal = __decorate([
        mobx_react_1.observer
    ], EstimateReentryModal);
    return EstimateReentryModal;
}(react_1.default.Component));
exports.default = EstimateReentryModal;
